import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'src/root/store';

import { esbApi } from '@modules/rtk/esb-api';
import { organizationTypeId } from '@shared/constants';
import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';

import type { NormalizedOrgProfile } from '../types';

const moduleSel = (state: RootState) => state.unit;

export const unitInfoSel = createSelector(
  moduleSel,
  state => state.unitInfo as NormalizedOrgProfile,
);

/**
 * Current unit profile based on the selected unit
 * i.e. `context.organizationGuid`
 */
export const unitProfileSel = createSelector(
  [
    organizationGuidSel,
    (state: RootState) => {
      const orgGuid = organizationGuidSel(state);
      return esbApi.endpoints.getOrganizationProfile.select({ orgGuid })(state)
        ?.data;
    },
  ],
  (_orgGuid, profileFromRTK) => profileFromRTK,
);

/**
 * This will be used to disable many actions from the UI like: viewing profiles from the roster items, nav items,
 * and some buttons in the Roster tab. See SBL-5832.
 */
export const isInactiveUnitSel = createSelector(
  unitProfileSel,
  unitProfile => unitProfile?.charter?.isActive === false, // strict equal to avoid false positives
);

export const isUnitTypeSel = createSelector(
  unitProfileSel,
  unitInfo =>
    unitInfo && unitInfo?.organizationTypeId === organizationTypeId.UNIT,
);
